import './frontend.scss';

const initInfoPageList = (infoPageList) => {
	// Define info page links with child items
	const linkWithChilden = infoPageList.querySelectorAll(
		'.page-item-has-children'
	);

	linkWithChilden.forEach((menu) => {
		const revealBtn = menu.querySelectorAll('.children-reveal-btn')[0];
		const childMenu = menu.querySelectorAll('.children')[0];
		const childMenuItems = childMenu.querySelectorAll('.page_item');

		// Childmenu links
		childMenuItems.forEach((childItem) => {
			// Reveal child menu on page load if any child page or child parent is opened
			if (
				childItem.classList.contains('is-current-page') ||
				childItem.parentElement.parentElement.classList.contains(
					'is-current-page'
				)
			) {
				revealBtn.classList.add('active');
				revealBtn.setAttribute('aria-expanded', 'true');
				childItem.parentElement.classList.add('active');
				childMenu.setAttribute('aria-expanded', 'true');
			}
		});

		// Reveal child menu with reveal button
		revealBtn.addEventListener('click', () => {
			revealBtn.classList.toggle('active');
			revealBtn.setAttribute(
				'aria-expanded',
				revealBtn.getAttribute('aria-expanded') !== 'true'
					? 'true'
					: 'false'
			);
			childMenu.classList.toggle('active');
			childMenu.setAttribute(
				'aria-expanded',
				childMenu.getAttribute('aria-expanded') !== 'true'
					? 'true'
					: 'false'
			);
		});
	});
};

// MOBILE INFO PAGE LIST
const initMobileInfoPageList = (mobileList) => {
	const mobileListRevealBtn = mobileList.querySelectorAll(
		'.mobile-info-page-list-reveal-btn'
	);
	const mobileListMenu = mobileList.querySelectorAll(
		'.info-page-link-list__top-level'
	);

	// Handle the mobile list reveal/hiding
	mobileListRevealBtn.forEach((button, i) => {
		button.addEventListener('click', () => {
			button.classList.toggle('active');
			button.setAttribute(
				'aria-expanded',
				button.getAttribute('aria-expanded') !== 'true'
					? 'true'
					: 'false'
			);
			mobileListMenu[i].classList.toggle('active');
			mobileListMenu[i].setAttribute(
				'aria-expanded',
				mobileListMenu[i].getAttribute('aria-expanded') !== 'true'
					? 'true'
					: 'false'
			);
		});
	});
};

// FEATURE INITIALIZATION
const init = () => {
	const infoPageLists = document.querySelectorAll(
		'.info-page-link-list > ul'
	);

	const mobileLists = document.querySelectorAll(
		'.info-page-link-list__mobile'
	);

	if (infoPageLists.length) {
		for (const infoPageList of infoPageLists) {
			initInfoPageList(infoPageList);
		}
	}

	if (mobileLists.length) {
		for (const mobileList of mobileLists) {
			initMobileInfoPageList(mobileList);
		}
	}
};

document.addEventListener('DOMContentLoaded', init);
